import { render, staticRenderFns } from "./default-select.vue?vue&type=template&id=610746d2&"
import script from "./default-select.vue?vue&type=script&lang=js&"
export * from "./default-select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports